import * as React from 'react';

import { LifeBuoyIcon, SendIcon } from 'lucide-react';

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { HELP_CENTER_URL } from '@/utils/helpCenter';
import { ChatwootWidgetTrigger } from './ChatwootWidget';

export const NavSecondary = ({
  ...props
}: React.ComponentProps<typeof SidebarGroup>) => {
  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild size="sm">
              <a target="_blank" href={HELP_CENTER_URL} rel="noreferrer">
                <LifeBuoyIcon />
                <span>Centro de ayuda</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild size="sm" className="cursor-pointer">
              <ChatwootWidgetTrigger>
                <SendIcon />
                <span>Hablar con soporte</span>
              </ChatwootWidgetTrigger>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
